module.exports = __webpack_public_path__ + "img/share_with.c1c9b1fb.svg";